import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BundleMixin from '@/helpers/vue_mixins/v2/BundleMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ActionButton from '@/components/action_button/Index.vue';
import Billing from '@/plugins/graphql/queries/v2/billing.gql';
import GracePeriodActivation from '@/components/v2/GracePeriodActivation.vue';
import ConvenienceFeeDetails from '@/components/v3/billing_manager/ConvenienceFeeDetails.vue';
import { BillingModel } from '@/helpers/entities/models/BillingModel';
import BillingPaymentDialog from '@/components/v2/BillingPaymentDialog.vue';
import BillingExportManager from '@/components/v2/BillingExportManager';
import { isNotEmpty } from '@/helpers';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { upcase } from '@/helpers/filters/string';
import { shortDate, shortMonthDay } from '@/helpers/DateFormatter';
import appDeactivated from '@/plugins/graphql/queries/v2/app-deactivated.gql';
import GenerateInvoice from '@/plugins/graphql/mutations/v3/generate-invoice-link.gql';
/**
 * Billing Details Page
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.6.0}
 */
let BillingDetails = class BillingDetails extends Mixins(BundleMixin, RouterParamsAppMixin, ViewportSizeMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.payOne = false;
        this.isRequestOnProcess = false;
        this.billing = null;
        this.appDeactivated = null;
    }
    onBillingPayment(billingReferenceNumber, billingPayAll) {
        this.isRequestOnProcess = true;
        this.$apollo
            .mutate({
            mutation: GenerateInvoice,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    referenceNumber: billingReferenceNumber,
                    payAll: billingPayAll,
                    successRedirectUrl: window.location.href,
                    failureRedirectUrl: window.location.href,
                },
            },
        })
            .then((res) => {
            if (res.data.generateInvoiceLink) {
                window.location.replace(res.data.generateInvoiceLink.url);
            }
        })
            .catch((err) => {
            this.errorNotification(err.message);
        })
            .finally(() => {
            this.isRequestOnProcess = false;
        });
    }
    goToBillingsPage() {
        this.$router.push({ name: 'billing', params: { appUuid: this.appUUID } });
    }
    hasDepositSlip(count) {
        return isNotEmpty(count);
    }
};
__decorate([
    Prop({ type: String, required: true })
], BillingDetails.prototype, "uuid", void 0);
BillingDetails = __decorate([
    Component({
        filters: { upcase, shortDate, shortMonthDay },
        apollo: {
            billing: {
                query: Billing,
                variables() {
                    return {
                        billingUuid: this.uuid,
                    };
                },
                update(data) {
                    return new BillingModel(data.billing);
                },
            },
            appDeactivated: {
                query: appDeactivated,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.app?.deactivated;
                },
            },
        },
        components: {
            ActionButton,
            BaseSubtitle,
            BillingPaymentDialog,
            BillingExportManager,
            GracePeriodActivation,
            PageTitle,
            ConvenienceFeeDetails,
            AlertMixin,
        },
    })
], BillingDetails);
export default BillingDetails;
